import * as DarkReader from 'darkreader';
const trustedOriginRegex = /^https:\/\/(local|app)(-[^.]+)?.hubspot(qa)?.com/;
window.addEventListener('message', event => {
  if (event.isTrusted && trustedOriginRegex.test(event.origin) && event.data.type === 'TOGGLE_DARK_MODE') {
    if (event.data.isDarkMode) {
      DarkReader.setFetchMethod(window.fetch);
      DarkReader.enable({
        brightness: 100,
        contrast: 90,
        sepia: 10
      });
    } else {
      DarkReader.disable();
    }
  }
});